import { useLocation } from "react-router-dom";

export function useQueryString<T = Record<string, string | null>>(): Partial<T> {
	const { search } = useLocation();
	if (!search) {
		return {} as Partial<T>;
	}

	const params = new URLSearchParams(search);
	const result = {} as Record<string, string | null>;

	params.forEach((value, key) => {
		result[key] = value || null;
	});

	return result as Partial<T>;
}
